<div class="trinka-credits">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>{{ title }}</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-md-12 col-lg-11">
                <div class="credit-section">
                    <div class="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" width="745" height="140" viewBox="0 0 745 140" fill="none">
                            <path d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z" fill="#F5ECFF"/>
                        </svg>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/new-credits.svg" width="26" height="25" alt="credits" />
                        </div>
                        <div class="media-body">
                            <h6 [innerHTML]="description"></h6>
                        </div>
                    </div>
                    <div class="image">
                        <img src="/assets/images/credits-banner.svg" width="190" height="138" alt="credits" />
                    </div>
                </div>
                <ul>
                    <li><span>*</span>
                        <p [innerHTML]="subText"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>